<template>
  <v-dialog
    v-model="drawer"
    fullscreen
    scrollable
    hide-overlay
  >
    <v-card
      style="position: relative;"
      class="quick-edit-view"
    >
      <v-card-title class="secondary mb-3 white--text">
        <v-row>
          <v-col>
            Quick Party Edit
          </v-col>
          <v-spacer />
          <v-col cols="auto">
            <v-tooltip bottom>
              <template
                #activator="{on, attrs}"
              >
                <v-btn
                  v-bind="attrs"
                  icon
                  color="white"
                  v-on="on"
                  @click="onFullPartyView"
                >
                  <v-icon>mdi-arrow-expand</v-icon>
                </v-btn>
              </template>
              <span>Open in dedicated view</span>
            </v-tooltip>
            <v-btn
              icon
              color="white"
              @click="onCloseDrawer"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row
            v-if="selectedComponent && peSharedQESliderPartyId"
            :class="partyOverviewIsCollapsed"
          >
            <v-col
              cols="auto"
            >
              <v-navigation-drawer
                permanent
                expand-on-hover
                class="d-sticky elevation-2"
                :height="null"
              >
                <v-list
                  nav
                  dense
                >
                  <v-list-item-group v-model="selectedSection">
                    <v-list-item
                      v-for="section of sections"
                      :key="section.route"
                      link
                      @click="selectSection(section)"
                    >
                      <v-list-item-icon>
                        <v-icon>{{ section.icon }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>{{ section.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-navigation-drawer>
            </v-col>
            <v-col class="mr-6">
              <PEHeader no-margin />
              <component
                :is="selectedComponent"
                :id="peSharedQESliderPartyId"
              />
            </v-col>
          </v-row>
          <PEOverviewSummary
            v-if="drawer"
            :collapsed="true"
          />
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { PARTY_NAMESPACE } from '@/store/party'
import PEAsylumAssistant from './PEAsylumAssistant.vue'
import PEBackground from './PEBackground.vue'
import PEElligibilityAssistant from './PEElligibilityAssistant.vue'
import PEFamilies from './PEFamilies.vue'
import PEHeader from './PEHeader.vue'
import PEHistory from './PEHistory.vue'
import PELongTermOptions from './PELongTermOptions.vue'
import PEOverviewSummary from './PEOverviewSummary.vue'
import PEPersonalDetails from './PEPersonalDetails.vue'

export default {
  name: 'PEQuickEdit',

  components: {
    PEHeader,
    PEOverviewSummary,
  },

  data () {
    return {
      sections: [
        { component: PEPersonalDetails, icon: 'person', route: 'pe-personal-details', title: 'Personal Details' },
        { component: PEFamilies, icon: 'groups', route: 'pe-family', title: 'Family' },
        { component: PEBackground, icon: 'explore', route: 'pe-background', title: 'Background' },
        { component: PEHistory, icon: 'alt_route', route: 'pe-history', title: 'History' },
        { component: PEElligibilityAssistant, icon: 'mdi-account-check', route: 'pe-eligibility-assistant', title: 'Eligibility Assistant' },
        { component: PEAsylumAssistant, icon: 'assistant', route: 'pe-asylum-assistant', title: 'Asylum Assistant' },
        { component: PELongTermOptions, icon: 'list', route: 'pe-long-term-options', title: 'Long Term Options' },
      ],

      selectedComponent: null,
      selectedSection: null,
    }
  },

  computed: {
    drawer: {
      get () {
        return this.peSharedQESliderStatus
      },

      set (value) {
        this.peSharedQESliderSetStatus(value)
      },
    },

    partyOverviewIsCollapsed () {
      return this.peOverviewSummaryCollapsed ? 'collapsed' : 'not-collapsed'
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peAnyUnlockedSections',
      'peOverviewSummaryCollapsed',
      'peSharedQESliderPartyId',
      'peSharedQESliderStatus',
    ]),
  },

  watch: {
    drawer: {
      deep: true,
      immediate: true,

      handler: function (val) {
        if (val) {
          this.selectSection(this.sections[0])
        } else {
          this.selectedComponent = null
        }
      },
    },
  },

  methods: {
    onCloseDrawer () {
      if (this.peAnyUnlockedSections) {
        const confirm = window.confirm('Are you sure you want to close the drawer? You will lose unsaved changes!')
        if (confirm) this.drawer = false
      } else {
        this.drawer = false
      }
    },

    onFullPartyView () {
      let canGo = true
      if (this.peAnyUnlockedSections) {
        canGo = window.confirm('Remember to save your changes before leaving this page. You will lose unsaved changes!')
      }

      if (!canGo) return

      const { href } = this.$router.resolve({ name: 'partyEdit', params: { id: this.peSharedQESliderPartyId } })
      window.open(href, '_blank')
    },

    selectSection (section) {
      this.selectedComponent = section.component
      this.peSharedQESliderUpdateSectionRoute(section.route)
    },

    ...mapActions(PARTY_NAMESPACE, [
      'peSharedQESliderSetStatus',
      'peSharedQESliderUpdateSectionRoute',
    ]),
  },
}
</script>

<style>
.d-sticky {
  position: sticky !important;
  z-index: 1;
  top: 0px;
}
</style>
